import { useNavigate } from "react-router-dom";
import Styles from "../../styles/coach/notfound.module.scss";

const NotFound = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/");
  };

  return (
    <div className={Styles.notFoundContainer}>
      <div className={Styles.notFoundContent}>
        <h1 className={Styles.errorCode}>404</h1>
        <h2 className={Styles.errorTitle}>Page Not Found</h2>
        <p className={Styles.errorMessage}>
          Sorry, the page you are looking for doesn't exist or has been moved.
        </p>
        <button className={Styles.homeButton} onClick={handleGoHome}>
          Go Back Home
        </button>
      </div>
    </div>
  );
};

export default NotFound;
